import { Button } from "@/components/ui/button";
import { useTranslation } from "@/hooks/useTranslation";
import type { PlanType } from "@/stores/planSelectionStore";

interface PendingPlanBannerProps {
  plan: PlanType;
  onCreateEvent: () => void;
  onDismiss: () => void;
}

/**
 * JUB-157: after registering with a paid plan, the new account creates its
 * event first; the dashboard then continues to payment for that event.
 */
export function PendingPlanBanner({ plan, onCreateEvent, onDismiss }: PendingPlanBannerProps) {
  const { t } = useTranslation();

  return (
    <div className="mb-6 rounded-lg border border-pink-200 bg-pink-50 px-4 py-3 text-sm dark:border-pink-900 dark:bg-pink-950/20" data-testid="pending-plan-banner">
      <p className="font-medium">{t("events.pendingPlan.title", { plan: t(`landing.pricing.${plan}.name`) || plan })}</p>
      <p className="mt-1 text-muted-foreground">{t("events.pendingPlan.description")}</p>
      <div className="mt-2 flex gap-2">
        <Button size="sm" onClick={onCreateEvent} data-testid="pending-plan-create-event">
          {t("events.create")}
        </Button>
        <Button size="sm" variant="ghost" onClick={onDismiss}>
          {t("common.cancel")}
        </Button>
      </div>
    </div>
  );
}
